// src/pages/Contacts/index.js (versão corrigida)
import React, {
  useState,
  useEffect,
  useReducer,
  useContext,
  useRef,
} from "react";
import { toast } from "react-toastify";
import { showSuccessToast, showWarningToast } from "../../utils/toastHelper";
import { useHistory, useLocation } from "react-router-dom";

import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { Facebook, Instagram, WhatsApp, Close, Group as GroupIcon } from "@material-ui/icons";
import SearchIcon from "@material-ui/icons/Search";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import IconButton from "@material-ui/core/IconButton";
import DeleteOutlineIcon from "@material-ui/icons/DeleteOutline";
import EditIcon from "@material-ui/icons/Edit";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import CancelIcon from "@material-ui/icons/Cancel";
import BlockIcon from "@material-ui/icons/Block";
import Checkbox from "@material-ui/core/Checkbox";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import Tooltip from "@material-ui/core/Tooltip";
import { alpha } from "@material-ui/core/styles";

import api from "../../services/api";
import TableRowSkeleton from "../../components/TableRowSkeleton";
import ContactModal from "../../components/ContactModal";
import ConfirmationModal from "../../components/ConfirmationModal/";
import ContactDeleteConfirmModal from "../../components/ContactDeleteConfirmModal";

import { i18n } from "../../translate/i18n";
import PageBase from "../../components/PageBase";
import toastError from "../../errors/toastError";

import { AuthContext } from "../../context/Auth/AuthContext";
import { Can } from "../../components/Can";
import NewTicketModal from "../../components/NewTicketModal";
import { TagsFilter } from "../../components/TagsFilter";
import PopupState, { bindTrigger, bindMenu } from "material-ui-popup-state";
import formatSerializedId, { FormattedPhoneNumber } from "../../utils/formatSerializedId";
import { v4 as uuidv4 } from "uuid";

import { ArrowDropDown, Backup, ContactPhone, DeleteSweep, AllInclusive, Person, Group as GroupFilterIcon } from "@material-ui/icons";
import { Menu, MenuItem, CircularProgress, LinearProgress, Box, Radio, RadioGroup, FormControlLabel, FormControl, TablePagination } from "@material-ui/core";

import ContactImportWpModal from "../../components/ContactImportWpModal";
import FixContactsLidModal from "../../components/FixContactsLidModal";
import useCompanySettings from "../../hooks/useSettings/companySettings";
import { TicketsContext } from "../../context/Tickets/TicketsContext";

const reducer = (state, action) => {
  if (action.type === "LOAD_CONTACTS") {
    return action.payload;
  }

  if (action.type === "UPDATE_CONTACTS") {
    const contact = action.payload;
    const contactIndex = state.findIndex((c) => c.id === contact.id);

    if (contactIndex !== -1) {
      state[contactIndex] = contact;
      return [...state];
    } else {
      return [contact, ...state];
    }
  }

  if (action.type === "DELETE_CONTACT") {
    const contactId = action.payload;
    const contactIndex = state.findIndex((c) => c.id === contactId);
    if (contactIndex !== -1) {
      state.splice(contactIndex, 1);
    }
    return [...state];
  }

  if (action.type === "BULK_DELETE_CONTACTS") {
    const contactIds = action.payload;
    return state.filter(contact => !contactIds.includes(contact.id));
  }

  if (action.type === "DELETE_ALL_CONTACTS") {
    const { excludeIds = [] } = action.payload;
    return state.filter(contact => excludeIds.includes(contact.id));
  }

  if (action.type === "RESET") {
    return [];
  }

  if (action.type === "SET_TOTAL_COUNT") {
    // Não altera o estado, mas permite rastrear o total
    return state;
  }
};

const useStyles = makeStyles((theme) => ({
  mainPaper: {
    flex: 1,
    minHeight: 0,
    display: "flex",
    flexDirection: "column",
  },
  avatarCell: {
    width: '60px',
    padding: theme.spacing(1),
  },
  idCell: {
    width: '80px',
  },
  checkboxCell: {
    width: '48px',
    padding: theme.spacing(0, 1),
  },
  clickableAvatar: {
    cursor: 'pointer',
    transition: 'transform 0.2s ease-in-out',
    '&:hover': {
      transform: 'scale(1.1)',
    },
  },
  imageDialog: {
    '& .MuiDialog-paper': {
      width: 'min(92vw, 560px)',
      maxWidth: '560px',
      borderRadius: 14,
      overflow: 'hidden',
    },
  },
  imageDialogTitle: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2, 3),
    color: '#fff',
    fontWeight: 600,
    background: theme.palette.type === 'dark'
      ? 'linear-gradient(135deg, #3b82f6 0%, #1e3a8a 100%)'
      : 'linear-gradient(135deg, #1d4ed8 0%, #7c3aed 100%)',
  },
  imageDialogContent: {
    padding: theme.spacing(2.5),
    backgroundColor: theme.palette.type === 'dark' ? theme.palette.background.default : '#fafafa',
  },
  imageFrame: {
    borderRadius: 12,
    border: `1px solid ${theme.palette.type === 'dark' ? '#444' : '#e5e7eb'}`,
    background: theme.palette.type === 'dark' ? '#1f1f1f' : '#fff',
    padding: theme.spacing(1.5),
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  profileImage: {
    width: '100%',
    height: 'auto',
    maxWidth: '100%',
    maxHeight: '62vh',
    objectFit: 'contain',
    borderRadius: 10,
  },
  toolbar: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(1),
    backgroundColor: alpha(theme.palette.primary.main, 0.12),
    minHeight: 48,
  },
  toolbarHighlight: {
    backgroundColor: alpha(theme.palette.primary.main, 0.25),
  },
  toolbarTitle: {
    flex: '1 1 100%',
    fontWeight: 600,
  },
  bulkActions: {
    display: 'flex',
    gap: theme.spacing(1),
  },
  filtersContainer: {
    display: 'flex',
    flex: 1,
    gap: theme.spacing(1),
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    alignItems: 'center',
  },
  filterItem: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    width: '100%',
  },
  contactTypeFilter: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginLeft: theme.spacing(1),
    verticalAlign: 'middle',
    '& fieldset': {
      border: 'none',
    },
  },
  radioGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing(0),
    alignItems: 'center',
  },
  radioLabel: {
    margin: 0,
    padding: theme.spacing(0.5, 1),
    '& .MuiRadio-root': {
      padding: theme.spacing(0.5),
    },
    '& .MuiFormControlLabel-label': {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(0.5),
      fontSize: '0.875rem',
    },
  },
}));

const Contacts = () => {
  const classes = useStyles();
  const history = useHistory();
  const location = useLocation();
  const { user, socket } = useContext(AuthContext);

  const [loading, setLoading] = useState(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageSize, setPageSize] = useState(100);
  const [searchParam, setSearchParam] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get("searchParam") || "";
  });
  const [isGroupFilter, setIsGroupFilter] = useState(null); // null = ambos, true = grupos, false = contatos
  const [contacts, dispatch] = useReducer(reducer, []);
  const [selectedContactId, setSelectedContactId] = useState(null);
  const [contactModalOpen, setContactModalOpen] = useState(false);
  const [totalContactsCount, setTotalContactsCount] = useState(0);

  // Estados para seleção múltipla
  const [selectedContacts, setSelectedContacts] = useState(new Set());
  const [selectAllMode, setSelectAllMode] = useState(false); // true = todos da empresa, false = apenas da página

  const [importContactModalOpen, setImportContactModalOpen] = useState(false);
  const [deletingContact, setDeletingContact] = useState(null);
  const [ImportContacts, setImportContacts] = useState(null);
  const [blockingContact, setBlockingContact] = useState(null);
  const [unBlockingContact, setUnBlockingContact] = useState(null);
  const [confirmOpen, setConfirmOpen] = useState(false);
  const [exportContact, setExportContact] = useState(false);
  const [confirmChatsOpen, setConfirmChatsOpen] = useState(false);
  const [hasMore, setHasMore] = useState(false);
  const [newTicketModalOpen, setNewTicketModalOpen] = useState(false);
  const [contactTicket, setContactTicket] = useState({});
  
  // Estados para exclusão múltipla com confirmação tipada
  const [deleteConfirmModalOpen, setDeleteConfirmModalOpen] = useState(false);
  const [deleteType, setDeleteType] = useState(''); // 'selected' ou 'all'
  
  const fileUploadRef = useRef(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const { setCurrentTicket } = useContext(TicketsContext);

  // Estados para o modal de imagem
  const [imageModalOpen, setImageModalOpen] = useState(false);
  const [selectedImage, setSelectedImage] = useState('');
  const [selectedContactName, setSelectedContactName] = useState('');

  const { getAll: getAllSettings } = useCompanySettings();
  const [hideNum, setHideNum] = useState(false);
  const [enableLGPD, setEnableLGPD] = useState(false);

  // Estados para importação de contatos do aparelho
  const [importProgressOpen, setImportProgressOpen] = useState(false);
  const [importProgress, setImportProgress] = useState({
    status: 'idle', // idle, starting, importing, completed, error
    phase: null, // null, 'groups', 'contacts'
    current: 0,
    total: 0,
    percentage: 0,
    message: '',
    contacts: null, // { total, created, updated, skipped }
    groups: null, // { total, created, updated, skipped }
    duration: null,
    created: 0,
    updated: 0,
    skipped: 0
  });
  
  // Estado para modal de saneamento de contatos LID
  const [fixLidModalOpen, setFixLidModalOpen] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const nextSearchParam = params.get("searchParam") || "";
    setSearchParam(prev => (prev === nextSearchParam ? prev : nextSearchParam));
    setPageNumber(1);
  }, [location.search]);
  
  useEffect(() => {
    async function fetchData() {
      const settingList = await getAllSettings(user.companyId);

      for (const [key, value] of Object.entries(settingList)) {
        if (key === "enableLGPD") setEnableLGPD(value === "enabled");
        if (key === "lgpdHideNumber") setHideNum(value === "enabled");
      }
    }
    fetchData();
  }, []);

  // Funções para seleção múltipla CORRIGIDAS
  const handleSelectContact = (contactId) => {
    const newSelected = new Set(selectedContacts);
    if (newSelected.has(contactId)) {
      newSelected.delete(contactId);
    } else {
      newSelected.add(contactId);
    }
    setSelectedContacts(newSelected);
    setSelectAllMode(false); // Desativa modo "todos da empresa" quando seleciona individualmente
  };

  const handleSelectAllContacts = () => {
    if (selectAllMode) {
      // Se já está em modo "todos", desmarcar tudo
      setSelectedContacts(new Set());
      setSelectAllMode(false);
    } else {
      // Verificar se todos da página atual estão selecionados
      const currentPageIds = contacts.map(contact => contact.id);
      const allCurrentSelected = currentPageIds.every(id => selectedContacts.has(id));
      
      if (allCurrentSelected && selectedContacts.size === currentPageIds.length) {
        // Se todos da página estão selecionados, ativar modo "todos da empresa"
        setSelectAllMode(true);
        setSelectedContacts(new Set()); // Limpar seleção individual
      } else {
        // Selecionar todos da página atual
        setSelectedContacts(new Set(currentPageIds));
        setSelectAllMode(false);
      }
    }
  };

  // Limpar seleção quando contatos mudam
  useEffect(() => {
    setSelectedContacts(new Set());
    setSelectAllMode(false);
  }, [searchParam, selectedTags, isGroupFilter]);

  // Função para obter contagem correta
  const getSelectedCount = () => {
    if (selectAllMode) {
      return totalContactsCount;
    }
    return selectedContacts.size;
  };

  // Função para obter texto do botão
  const getSelectionButtonText = () => {
    if (selectAllMode) {
      return i18n.t("contacts.bulk.deleteAllWithCount", { count: totalContactsCount });
    }
    if (selectedContacts.size > 0) {
      return i18n.t("contacts.bulk.deleteSelectedWithCount", { count: selectedContacts.size });
    }
    return i18n.t("contacts.bulk.delete");
  };

  // Funções para exclusão múltipla CORRIGIDAS
  const handleBulkDeleteClick = () => {
    if (selectAllMode) {
      setDeleteType('all');
    } else if (selectedContacts.size > 0) {
      setDeleteType('selected');
    } else {
      showWarningToast("Selecione pelo menos um contato para excluir");
      return;
    }
    setDeleteConfirmModalOpen(true);
  };

  const handleBulkDeleteConfirm = async () => {
    try {
      if (deleteType === 'all') {
        await api.delete("/contacts/all", {
          data: {
            confirmation: "DELETE_ALL_CONTACTS",
            excludeIds: []
          }
        });
        showSuccessToast(`Todos os ${totalContactsCount} contatos foram excluídos`);
      } else {
        const contactIds = Array.from(selectedContacts);
        await api.post("/contacts/bulk-delete", { contactIds });
        showSuccessToast(`${contactIds.length} contatos excluídos com sucesso`);
      }
      
      // Resetar seleções
      setSelectedContacts(new Set());
      setSelectAllMode(false);
      
      // Atualizar lista
      setSearchParam("");
      setPageNumber(1);
      
    } catch (err) {
      toastError(err);
    } finally {
      setDeleteConfirmModalOpen(false);
      setDeleteType('');
    }
  };

  const handleDeleteAllClick = () => {
    setDeleteType('all');
    setDeleteConfirmModalOpen(true);
  };

  // Função para abrir modal da imagem
  const handleOpenImageModal = (imageUrl, contactName) => {
    setSelectedImage(imageUrl);
    setSelectedContactName(contactName);
    setImageModalOpen(true);
  };

  // Função para fechar modal da imagem
  const handleCloseImageModal = () => {
    setImageModalOpen(false);
    setSelectedImage('');
    setSelectedContactName('');
  };

  const handleImportExcel = async () => {
    try {
      const formData = new FormData();
      formData.append("file", fileUploadRef.current.files[0]);
      await api.request({
        url: `/contacts/upload`,
        method: "POST",
        data: formData,
      });
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  useEffect(() => {
    dispatch({ type: "RESET" });
    setPageNumber(1);
  }, [searchParam, selectedTags, isGroupFilter]);

  useEffect(() => {
    setPageNumber(1);
  }, [pageSize]);

  useEffect(() => {
    setLoading(true);
    const delayDebounceFn = setTimeout(() => {
      const fetchContacts = async () => {
        try {
          const params = {
            searchParam,
            pageNumber,
            pageSize,
            limit: pageSize,
            contactTag: JSON.stringify(selectedTags),
          };
          
          // Adicionar filtro isGroup apenas se não for null (ambos)
          // Converter boolean para string para compatibilidade com backend
          if (isGroupFilter !== null) {
            params.isGroup = String(isGroupFilter);
          }
          
          const { data } = await api.get("/contacts/", { params });
          dispatch({ type: "LOAD_CONTACTS", payload: data.contacts });
          setHasMore(data.hasMore);
          setTotalContactsCount(data.count); // Armazenar contagem total
          setLoading(false);
        } catch (err) {
          toastError(err);
        }
      };
      fetchContacts();
    }, 500);
    return () => clearTimeout(delayDebounceFn);
  }, [searchParam, pageNumber, pageSize, selectedTags, isGroupFilter]);

  useEffect(() => {
    const companyId = user.companyId;

    const onContactEvent = (data) => {
      if (data.action === "update" || data.action === "create") {
        dispatch({ type: "UPDATE_CONTACTS", payload: data.contact });
      }

      if (data.action === "delete") {
        dispatch({ type: "DELETE_CONTACT", payload: +data.contactId });
        setTotalContactsCount(prev => Math.max(0, prev - 1));
      }

      if (data.action === "bulk-delete") {
        dispatch({ type: "BULK_DELETE_CONTACTS", payload: data.contactIds });
        setTotalContactsCount(prev => Math.max(0, prev - data.contactIds.length));
      }

      if (data.action === "delete-all") {
        dispatch({ type: "DELETE_ALL_CONTACTS", payload: { excludeIds: data.excludeIds } });
        setTotalContactsCount(data.excludeIds.length);
      }
    };
    
    socket.on(`company-${companyId}-contact`, onContactEvent);

    // Listener para progresso de importação de contatos
    const importEventName = `importContacts-${companyId}`;
    console.log("[IMPORT_CONTACTS] Registering listener for:", importEventName, "socket connected:", socket?.connected);
    
    const onImportContactsEvent = (data) => {
      console.log("[IMPORT_CONTACTS] Event received:", data);
      
      if (data.action === "start") {
        setImportProgress({
          status: 'starting',
          current: 0,
          total: 0,
          percentage: 0,
          message: data.message || i18n.t("contacts.importProgress.starting"),
          created: 0,
          updated: 0,
          skipped: 0
        });
      }
      
      if (data.action === "progress") {
        setImportProgress(prev => ({
          ...prev,
          status: 'importing',
          phase: data.phase || prev.phase || null,
          current: data.current || 0,
          total: data.total || 0,
          percentage: data.percentage || 0,
          message: data.message || i18n.t("contacts.importProgress.importing")
        }));
      }
      
      if (data.action === "complete") {
        setImportProgress({
          status: 'completed',
          phase: null,
          current: data.total || 0,
          total: data.total || 0,
          percentage: 100,
          message: data.message || i18n.t("contacts.importProgress.completed"),
          // Novos campos para resultados detalhados
          contacts: data.contacts || null,
          groups: data.groups || null,
          duration: data.duration || null,
          // Campos legados (fallback)
          created: data.contacts?.created || data.created || 0,
          updated: data.contacts?.updated || data.updated || 0,
          skipped: data.contacts?.skipped || data.skipped || 0
        });
        
        // Recarregar contatos após importação
        setTimeout(() => {
          setPageNumber(1);
          setSearchParam('');
        }, 1500);
      }
      
      if (data.action === "error") {
        setImportProgress(prev => ({
          ...prev,
          status: 'error',
          phase: null,
          message: data.message || i18n.t("contacts.importProgress.error")
        }));
      }
    };

    socket.on(importEventName, onImportContactsEvent);

    return () => {
      console.log("[IMPORT_CONTACTS] Cleaning up listener for:", importEventName);
      socket.off(`company-${companyId}-contact`, onContactEvent);
      socket.off(importEventName, onImportContactsEvent);
    };
  }, [socket]);

  const handleSelectTicket = (ticket) => {
    const code = uuidv4();
    const { id, uuid, status } = ticket;
    setCurrentTicket({ id, uuid, status, code });
  };

  const handleCloseOrOpenTicket = (ticket) => {
    setNewTicketModalOpen(false);
    if (ticket !== undefined && ticket.uuid !== undefined) {
      handleSelectTicket(ticket);
      history.push(`/tickets/${ticket.uuid}`);
    }
  };

  const handleSelectedTags = (selecteds) => {
    const tags = selecteds.map((t) => t.id);
    setSelectedTags(tags);
  };

  const handleSearch = (event) => {
    setSearchParam(event.target.value.toLowerCase());
  };

  const handleOpenContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(true);
  };

  const handleCloseContactModal = () => {
    setSelectedContactId(null);
    setContactModalOpen(false);
  };

  const hadleEditContact = (contactId) => {
    setSelectedContactId(contactId);
    setContactModalOpen(true);
  };

  const handleDeleteContact = async (contactId) => {
    try {
      await api.delete(`/contacts/${contactId}`);
      showSuccessToast(i18n.t("contacts.toasts.deleted"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
  };

  const handleBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: false });
      showSuccessToast(i18n.t("contacts.toasts.blocked"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
    setBlockingContact(null);
  };

  const handleUnBlockContact = async (contactId) => {
    try {
      await api.put(`/contacts/block/${contactId}`, { active: true });
      showSuccessToast(i18n.t("contacts.toasts.unblocked"));
    } catch (err) {
      toastError(err);
    }
    setDeletingContact(null);
    setSearchParam("");
    setPageNumber(1);
    setUnBlockingContact(null);
  };

  const handleimportContact = async () => {
    try {
      // Abrir modal de progresso
      setImportProgressOpen(true);
      setImportProgress({
        status: 'starting',
        current: 0,
        total: 0,
        percentage: 0,
        message: i18n.t("contacts.importProgress.startingImport"),
        created: 0,
        updated: 0,
        skipped: 0
      });
      setImportContacts(false);
      setConfirmOpen(false);
      
      // Chamar API (o progresso será recebido via socket)
      await api.post("/contacts/import");
      
    } catch (err) {
      toastError(err);
      setImportProgress(prev => ({
        ...prev,
        status: 'error',
        message: err.response?.data?.message || i18n.t("contacts.importProgress.importError")
      }));
      setImportContacts(false);
    }
  };

  const handleimportChats = async () => {
    try {
      await api.post("/contacts/import/chats");
      history.go(0);
    } catch (err) {
      toastError(err);
    }
  };

  // Infinite scroll replaced by standard pagination

  // Determinar qual ação de confirmação executar para modais simples
  const getConfirmAction = () => {
    if (deletingContact) return () => handleDeleteContact(deletingContact.id);
    if (blockingContact) return () => handleBlockContact(blockingContact.id);
    if (unBlockingContact) return () => handleUnBlockContact(unBlockingContact.id);
    if (ImportContacts) return handleimportContact;
    return handleImportExcel;
  };

  // Determinar título do modal de confirmação simples
  const getConfirmTitle = () => {
    if (deletingContact) return `${i18n.t("contacts.confirmationModal.deleteTitle")} ${deletingContact.name}?`;
    if (blockingContact) return `Bloquear Contato ${blockingContact.name}?`;
    if (unBlockingContact) return `Desbloquear Contato ${unBlockingContact.name}?`;
    if (ImportContacts) return i18n.t("contacts.confirmationModal.importTitlte");
    return i18n.t("contactListItems.confirmationModal.importTitlte");
  };

  // Determinar mensagem do modal de confirmação simples
  const getConfirmMessage = () => {
    if (exportContact) return i18n.t("contacts.confirmationModal.exportContact");
    if (deletingContact) return i18n.t("contacts.confirmationModal.deleteMessage");
    if (blockingContact) return i18n.t("contacts.confirmationModal.blockContact");
    if (unBlockingContact) return i18n.t("contacts.confirmationModal.unblockContact");
    if (ImportContacts) return i18n.t("contacts.confirmationModal.importMessage");
    return i18n.t("contactListItems.confirmationModal.importMessage");
  };

  const selectedCount = getSelectedCount();
  const isAnyContactSelected = selectAllMode || selectedContacts.size > 0;

  // Status do checkbox "selecionar todos"
  const selectAllCheckboxStatus = () => {
    if (selectAllMode) return { checked: true, indeterminate: false };
    
    const currentPageIds = contacts.map(contact => contact.id);
    const selectedInCurrentPage = currentPageIds.filter(id => selectedContacts.has(id)).length;
    
    if (selectedInCurrentPage === 0) {
      return { checked: false, indeterminate: false };
    } else if (selectedInCurrentPage === currentPageIds.length) {
      return { checked: true, indeterminate: false };
    } else {
      return { checked: false, indeterminate: true };
    }
  };

  const checkboxStatus = selectAllCheckboxStatus();

  return (
    <PageBase
      className="contacts-page"
      title={
        <>
          {i18n.t("contacts.title")} ({totalContactsCount})
          {isAnyContactSelected && (
            <span style={{ color: '#f50057', fontSize: '16px', fontWeight: 'normal', marginLeft: 8 }}>
              - {i18n.t("contacts.bulk.selectedSummary", { count: selectedCount })} {selectAllMode && i18n.t("contacts.bulk.allShort")}
            </span>
          )}
        </>
      }
      actions={
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, flexWrap: 'wrap' }}>
          {isAnyContactSelected && (
            <Tooltip title={selectAllMode ? i18n.t("contacts.bulk.deleteAllTooltip") : i18n.t("contacts.bulk.deleteSelectedTooltip")}>
              <Button
                variant="contained"
                color="secondary"
                startIcon={<DeleteOutlineIcon />}
                onClick={handleBulkDeleteClick}
                size="small"
              >
                {getSelectionButtonText()}
              </Button>
            </Tooltip>
          )}

          <PopupState variant="popover" popupId="demo-popup-menu">
            {(popupState) => (
              <React.Fragment>
                <Button
                  variant="contained"
                  color="primary"
                  size="small"
                  {...bindTrigger(popupState)}
                >
                  {i18n.t("contacts.menu.importexport")}
                  <ArrowDropDown />
                </Button>
                <Menu {...bindMenu(popupState)}>
                  <MenuItem
                    onClick={() => {
                      setConfirmOpen(true);
                      setImportContacts(true);
                      popupState.close();
                    }}
                  >
                    <ContactPhone
                      fontSize="small"
                      color="primary"
                      style={{ marginRight: 10 }}
                    />
                    {i18n.t("contacts.menu.importYourPhone")}
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      setImportContactModalOpen(true);
                    }}
                  >
                    <Backup
                      fontSize="small"
                      color="primary"
                      style={{ marginRight: 10 }}
                    />
                    {i18n.t("contacts.menu.importToExcel")}
                  </MenuItem>
                  <Can
                    role={user.profile}
                    perform="contacts-page:deleteAllContacts"
                    yes={() => (
                      <MenuItem
                        onClick={() => {
                          handleDeleteAllClick();
                          popupState.close();
                        }}
                        style={{ color: '#f44336' }}
                      >
                        <DeleteSweep
                          fontSize="small"
                          style={{ marginRight: 10, color: '#f44336' }}
                        />
                        {i18n.t("contacts.bulk.deleteAllContacts")}
                      </MenuItem>
                    )}
                  />
                </Menu>
              </React.Fragment>
            )}
          </PopupState>
          
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleOpenContactModal}
          >
            {i18n.t("contacts.buttons.add")}
          </Button>
          
          <Tooltip title={i18n.t("contacts.fixContactsLid.tooltip") || "Corrigir contatos duplicados (LID como número)"}>
            <Button
              variant="outlined"
              color="secondary"
              size="small"
              onClick={() => setFixLidModalOpen(true)}
            >
              <Backup style={{ marginRight: 8 }} />
              {i18n.t("contacts.fixContactsLid.button") || "Corrigir LID"}
            </Button>
          </Tooltip>
        </div>
      }
      toolbar={
        <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap', width: '100%' }}>
          <div style={{ flex: 1, minWidth: '200px' }}>
            <TextField
              placeholder={i18n.t("contacts.searchPlaceholder")}
              type="search"
              value={searchParam}
              onChange={handleSearch}
              fullWidth
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon color="secondary" />
                  </InputAdornment>
                ),
              }}
            />
          </div>
          <div style={{ minWidth: '150px' }}>
            <TagsFilter onFiltered={handleSelectedTags} />
          </div>
          <div>
            <FormControl component="fieldset">
              <RadioGroup
                row
                value={isGroupFilter === null ? "ambos" : isGroupFilter ? "grupo" : "contato"}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value === "ambos") {
                    setIsGroupFilter(null);
                  } else if (value === "grupo") {
                    setIsGroupFilter(true);
                  } else {
                    setIsGroupFilter(false);
                  }
                }}
              >
                <FormControlLabel
                  value="ambos"
                  control={<Radio color="primary" size="small" />}
                  label={
                    <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '14px' }}>
                      <AllInclusive fontSize="small" />
                      Ambos
                    </span>
                  }
                />
                <FormControlLabel
                  value="contato"
                  control={<Radio color="primary" size="small" />}
                  label={
                    <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '14px' }}>
                      <Person fontSize="small" />
                      Contato
                    </span>
                  }
                />
                <FormControlLabel
                  value="grupo"
                  control={<Radio color="primary" size="small" />}
                  label={
                    <span style={{ display: 'flex', alignItems: 'center', gap: 4, fontSize: '14px' }}>
                      <GroupFilterIcon fontSize="small" />
                      Grupo
                    </span>
                  }
                />
              </RadioGroup>
            </FormControl>
          </div>
        </div>
      }
      containerProps={{
        className: classes.mainPaper,
      }}
    >
      <NewTicketModal
        modalOpen={newTicketModalOpen}
        initialContact={contactTicket}
        onClose={(ticket) => {
          handleCloseOrOpenTicket(ticket);
        }}
      />
      <ContactModal
        open={contactModalOpen}
        onClose={handleCloseContactModal}
        aria-labelledby="form-dialog-title"
        contactId={selectedContactId}
      ></ContactModal>
      
      {/* Modal de confirmação tipada para exclusão */}
      <ContactDeleteConfirmModal
        open={deleteConfirmModalOpen}
        onClose={() => setDeleteConfirmModalOpen(false)}
        onConfirm={handleBulkDeleteConfirm}
        deleteType={deleteType}
        selectedCount={selectedContacts.size}
        totalCount={totalContactsCount}
      />
      
      {/* Modal para visualizar imagem de perfil */}
      <Dialog
        open={imageModalOpen}
        onClose={handleCloseImageModal}
        className={classes.imageDialog}
        maxWidth={false}
      >
        <DialogTitle className={classes.imageDialogTitle}>
          <span>{i18n.t("contacts.profileImageTitle") || "Foto de Perfil"}</span>
          <IconButton
            onClick={handleCloseImageModal}
            size="small"
            style={{ color: '#fff', position: 'absolute', top: 10, right: 12 }}
          >
            <Close />
          </IconButton>
        </DialogTitle>
        <DialogContent dividers className={classes.imageDialogContent}>
          <Typography
            variant="subtitle1"
            style={{ marginBottom: 12, fontWeight: 600 }}
          >
            {selectedContactName || "-"}
          </Typography>
          {selectedImage ? (
            <div className={classes.imageFrame}>
              <img
                src={selectedImage}
                alt={`Foto de perfil de ${selectedContactName}`}
                className={classes.profileImage}
                onError={(e) => {
                  e.target.style.display = 'none';
                }}
              />
            </div>
          ) : (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              height: '200px',
              color: '#666'
            }}>
              Imagem não disponível
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Modal de confirmação simples para outras ações */}
      <ConfirmationModal
        title={getConfirmTitle()}
        open={confirmOpen}
        onClose={setConfirmOpen}
        onConfirm={getConfirmAction()}
      >
        {getConfirmMessage()}
      </ConfirmationModal>
      
      <ConfirmationModal
        title={i18n.t("contacts.confirmationModal.importChat")}
        open={confirmChatsOpen}
        onClose={setConfirmChatsOpen}
        onConfirm={(e) => handleimportChats()}
      >
        {i18n.t("contacts.confirmationModal.wantImport")}
      </ConfirmationModal>

      {/* Modal de progresso de importação de contatos do aparelho */}
      <Dialog
        open={importProgressOpen}
        maxWidth="sm"
        fullWidth
        disableBackdropClick={importProgress.status === 'importing' || importProgress.status === 'starting'}
        disableEscapeKeyDown={importProgress.status === 'importing' || importProgress.status === 'starting'}
      >
        <DialogTitle style={{ textAlign: 'center', paddingBottom: 0 }}>
          {i18n.t("contacts.importProgress.title") || "Importar Contatos do Aparelho"}
        </DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" alignItems="center" py={2}>
            {/* Status Icon com animação */}
            {(importProgress.status === 'starting' || importProgress.status === 'importing') && (
              <Box position="relative" display="inline-flex" mb={2}>
                <CircularProgress 
                  size={80} 
                  thickness={4}
                  variant={importProgress.total > 0 ? "determinate" : "indeterminate"}
                  value={importProgress.percentage || 0}
                  style={{ color: '#3f51b5' }}
                />
                {importProgress.total > 0 && (
                  <Box
                    top={0}
                    left={0}
                    bottom={0}
                    right={0}
                    position="absolute"
                    display="flex"
                    alignItems="center"
                    justifyContent="center"
                  >
                    <Typography variant="h6" component="div" color="textSecondary">
                      {importProgress.percentage}%
                    </Typography>
                  </Box>
                )}
              </Box>
            )}
            {importProgress.status === 'completed' && (
              <CheckCircleIcon style={{ fontSize: 80, color: '#4caf50', marginBottom: 16 }} />
            )}
            {importProgress.status === 'error' && (
              <CancelIcon style={{ fontSize: 80, color: '#f44336', marginBottom: 16 }} />
            )}

            {/* Fase atual (grupos ou contatos) */}
            {importProgress.phase && importProgress.status === 'importing' && (
              <Typography variant="subtitle2" color="primary" gutterBottom>
                {importProgress.phase === 'groups' ? i18n.t("contacts.importProgress.processingGroups") : i18n.t("contacts.importProgress.processingContacts")}
              </Typography>
            )}

            {/* Message */}
            <Typography variant="body1" align="center" gutterBottom style={{ fontWeight: 500 }}>
              {importProgress.message}
            </Typography>

            {/* Progress Bar detalhada */}
            {importProgress.status === 'importing' && importProgress.total > 0 && (
              <Box width="100%" mt={2}>
                <LinearProgress 
                  variant="determinate" 
                  value={importProgress.percentage} 
                  style={{ height: 12, borderRadius: 6, backgroundColor: '#e0e0e0' }}
                />
                <Box display="flex" justifyContent="space-between" mt={1}>
                  <Typography variant="body2" color="textSecondary">
                    {i18n.t("contacts.importProgress.processed")}: <strong>{importProgress.current}</strong>
                  </Typography>
                  <Typography variant="body2" color="textSecondary">
                    Total: <strong>{importProgress.total}</strong>
                  </Typography>
                </Box>
              </Box>
            )}

            {/* Indicador de espera quando não há total ainda */}
            {importProgress.status === 'importing' && importProgress.total === 0 && (
              <Box width="100%" mt={2}>
                <LinearProgress style={{ height: 8, borderRadius: 4 }} />
                <Typography variant="body2" color="textSecondary" align="center" style={{ marginTop: 8 }}>
                  {i18n.t("contacts.importProgress.fetchingWhatsapp")}
                </Typography>
              </Box>
            )}

            {/* Results detalhados */}
            {importProgress.status === 'completed' && (
              <Box mt={3} width="100%">
                {/* Resultados de Grupos */}
                {importProgress.groups && (
                  <Box mb={2} p={2} style={{ backgroundColor: '#f5f5f5', borderRadius: 8 }}>
                    <Typography variant="subtitle2" color="primary" gutterBottom>
                      {i18n.t("contacts.importProgress.groupsTitle", { count: importProgress.groups.total || 0 })}
                    </Typography>
                    <Box display="flex" justifyContent="space-around">
                      <Box textAlign="center">
                        <Typography variant="h6" style={{ color: '#4caf50' }}>
                          {importProgress.groups.created || 0}
                        </Typography>
                        <Typography variant="caption">{i18n.t("contacts.importProgress.created")}</Typography>
                      </Box>
                      <Box textAlign="center">
                        <Typography variant="h6" style={{ color: '#2196f3' }}>
                          {importProgress.groups.updated || 0}
                        </Typography>
                        <Typography variant="caption">{i18n.t("contacts.importProgress.updated")}</Typography>
                      </Box>
                      <Box textAlign="center">
                        <Typography variant="h6" style={{ color: '#9e9e9e' }}>
                          {importProgress.groups.skipped || 0}
                        </Typography>
                        <Typography variant="caption">{i18n.t("contacts.importProgress.skipped")}</Typography>
                      </Box>
                    </Box>
                  </Box>
                )}
                
                {/* Resultados de Contatos */}
                {importProgress.contacts && (
                  <Box p={2} style={{ backgroundColor: '#f5f5f5', borderRadius: 8 }}>
                    <Typography variant="subtitle2" color="primary" gutterBottom>
                      {i18n.t("contacts.importProgress.contactsTitle", { count: importProgress.contacts.total || 0 })}
                    </Typography>
                    {importProgress.contacts.total > 0 ? (
                      <Box display="flex" justifyContent="space-around">
                        <Box textAlign="center">
                          <Typography variant="h6" style={{ color: '#4caf50' }}>
                            {importProgress.contacts.created || 0}
                          </Typography>
                          <Typography variant="caption">{i18n.t("contacts.importProgress.created")}</Typography>
                        </Box>
                        <Box textAlign="center">
                          <Typography variant="h6" style={{ color: '#2196f3' }}>
                            {importProgress.contacts.updated || 0}
                          </Typography>
                          <Typography variant="caption">{i18n.t("contacts.importProgress.updated")}</Typography>
                        </Box>
                        <Box textAlign="center">
                          <Typography variant="h6" style={{ color: '#9e9e9e' }}>
                            {importProgress.contacts.skipped || 0}
                          </Typography>
                          <Typography variant="caption">{i18n.t("contacts.importProgress.skipped")}</Typography>
                        </Box>
                      </Box>
                    ) : (
                      <Box mt={1}>
                        <Typography variant="body2" color="textSecondary" align="center">
                          {i18n.t("contacts.importProgress.whatsappWebNoSync")}
                        </Typography>
                        <Typography variant="body2" color="textSecondary" align="center" style={{ marginTop: 4 }}>
                          {i18n.t("contacts.importProgress.contactsCreatedOnMessages")}
                        </Typography>
                      </Box>
                    )}
                  </Box>
                )}

                {/* Fallback para formato antigo */}
                {!importProgress.groups && !importProgress.contacts && (
                  <Box textAlign="center">
                    <Typography variant="body1">
                      <strong>{importProgress.created || 0}</strong> {i18n.t("contacts.importProgress.created") || "criados"}
                    </Typography>
                    <Typography variant="body1">
                      <strong>{importProgress.updated || 0}</strong> {i18n.t("contacts.importProgress.updated") || "atualizados"}
                    </Typography>
                    <Typography variant="body1" color="textSecondary">
                      <strong>{importProgress.skipped || 0}</strong> {i18n.t("contacts.importProgress.skipped") || "ignorados"}
                    </Typography>
                  </Box>
                )}

                {/* Tempo de execução */}
                {importProgress.duration && (
                  <Typography variant="caption" color="textSecondary" align="center" display="block" style={{ marginTop: 16 }}>
                    {i18n.t("contacts.importProgress.duration", { seconds: (importProgress.duration / 1000).toFixed(1) })}
                  </Typography>
                )}
              </Box>
            )}
          </Box>
        </DialogContent>
        {(importProgress.status === 'completed' || importProgress.status === 'error') && (
          <Box display="flex" justifyContent="center" pb={3}>
            <Button 
              variant="contained" 
              color="primary" 
              size="large"
              onClick={() => {
                setImportProgressOpen(false);
                if (importProgress.status === 'completed') {
                  // Recarregar página para mostrar novos contatos
                  window.location.reload();
                }
              }}
            >
              {importProgress.status === 'completed' 
                ? (i18n.t("contacts.importProgress.closeAndRefresh") || "Fechar e Atualizar")
                : (i18n.t("contacts.importProgress.close") || "Fechar")}
            </Button>
          </Box>
        )}
      </Dialog>

      {fixLidModalOpen && (
        <FixContactsLidModal
          open={fixLidModalOpen}
          onClose={() => setFixLidModalOpen(false)}
        />
      )}

      {importContactModalOpen && (
        <ContactImportWpModal
          isOpen={importContactModalOpen}
          handleClose={() => setImportContactModalOpen(false)}
          selectedTags={selectedTags}
          hideNum={hideNum}
          userProfile={user.profile}
        />
      )}
        <input
          style={{ display: "none" }}
          id="upload"
          name="file"
          type="file"
          accept=".xls,.xlsx"
          onChange={() => {
            setConfirmOpen(true);
          }}
          ref={fileUploadRef}
        />

        {/* Toolbar para ações em lote */}
        {isAnyContactSelected && (
          <Toolbar className={`${classes.toolbar} ${classes.toolbarHighlight}`}>
            <Typography className={classes.toolbarTitle} color="inherit" variant="subtitle1">
              {i18n.t("contacts.bulk.selectedContactsSummary", { count: selectedCount })} {selectAllMode && i18n.t("contacts.bulk.allContacts")}
            </Typography>
            <div className={classes.bulkActions}>
              <Tooltip title={i18n.t("contacts.bulk.cancelSelection")}>
                <Button
                  size="small"
                  onClick={() => {
                    setSelectedContacts(new Set());
                    setSelectAllMode(false);
                  }}
                >
                  {i18n.t("common.buttons.cancel")}
                </Button>
              </Tooltip>
              <Tooltip title={selectAllMode ? i18n.t("contacts.bulk.deleteAllTooltip") : i18n.t("contacts.bulk.deleteSelected")}>
                <IconButton
                  color="inherit"
                  onClick={handleBulkDeleteClick}
                >
                  <DeleteOutlineIcon />
                </IconButton>
              </Tooltip>
            </div>
          </Toolbar>
        )}

        <div className="page-table-wrapper">
          <Table size="small" stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell className={classes.checkboxCell}>
                <Checkbox
                  indeterminate={checkboxStatus.indeterminate}
                  checked={checkboxStatus.checked}
                  onChange={handleSelectAllContacts}
                  disabled={contacts.length === 0}
                  inputProps={{ 'aria-label': i18n.t("contacts.bulk.selectAllAria") }}
                />
              </TableCell>
              <TableCell className={classes.idCell}>ID</TableCell>
              <TableCell className={classes.avatarCell} align="center">{i18n.t("contacts.table.photo")}</TableCell>
              <TableCell>{i18n.t("contacts.table.name")}</TableCell>
              <TableCell align="center">
                {i18n.t("contacts.table.whatsapp")}
              </TableCell>
              <TableCell align="center">
                {i18n.t("contacts.table.email")}
              </TableCell>
              <TableCell align="center">{i18n.t("contacts.table.status")}</TableCell>
              <TableCell align="center">{i18n.t("contacts.table.wallet")}</TableCell>
              <TableCell align="center">
                {i18n.t("contacts.table.actions")}
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <>
              {contacts.map((contact) => {
                const isSelected = selectAllMode || selectedContacts.has(contact.id);
                
                return (
                  <TableRow 
                    key={contact.id}
                    selected={isSelected}
                  >
                    <TableCell className={classes.checkboxCell}>
                      <Checkbox
                        checked={isSelected}
                        onChange={() => handleSelectContact(contact.id)}
                        disabled={selectAllMode}
                      inputProps={{ 'aria-label': i18n.t("contacts.bulk.selectContactAria", { name: contact.name }) }}
                      />
                    </TableCell>
                    <TableCell className={classes.idCell}>{contact.id}</TableCell>
                    <TableCell className={classes.avatarCell} align="center">
                      <Avatar 
                        src={`${contact?.profilePicUrl || contact?.urlPicture}`}
                        className={classes.clickableAvatar}
                        onClick={() => handleOpenImageModal(contact?.profilePicUrl || contact?.urlPicture, contact.name)}
                      />
                    </TableCell>
                    <TableCell>{contact.name}</TableCell>
                    <TableCell align="center">
                      {enableLGPD && hideNum && user.profile === "user"
                        ? contact.isGroup
                          ? <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                              <GroupIcon style={{ color: '#25D366', fontSize: 18 }} />
                              <span style={{ fontSize: 12, color: '#666' }}>{i18n.t("contacts.group")}</span>
                            </span>
                          : formatSerializedId(contact?.number) === null
                          ? contact.number.slice(0, -6) +
                            "**-**" +
                            contact?.number.slice(-2)
                          : formatSerializedId(contact?.number)?.slice(0, -6) +
                            "**-**" +
                            contact?.number?.slice(-2)
                        : contact.isGroup
                        ? <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6 }}>
                            <GroupIcon style={{ color: '#25D366', fontSize: 18 }} />
                            <span style={{ fontSize: 12, color: '#666' }}>{i18n.t("contacts.group")}</span>
                          </span>
                        : contact?.number 
                          ? <FormattedPhoneNumber serializedId={contact.number} />
                          : "-"}
                    </TableCell>
                    <TableCell align="center">{contact.email}</TableCell>
                    <TableCell align="center">
                      {contact.active ? (
                        <CheckCircleIcon
                          style={{ color: "green" }}
                          fontSize="small"
                        />
                      ) : (
                        <CancelIcon style={{ color: "red" }} fontSize="small" />
                      )}
                    </TableCell>
                    <TableCell align="center">
                      {contact.contactWallets && contact.contactWallets.length > 0 
                        ? contact.contactWallets[0].wallet?.name || "Usuário não encontrado"
                        : "Não atribuído"}
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title={i18n.t("contacts.tooltips.sendMessage")}>
                        <span>
                          <IconButton
                            size="small"
                            disabled={!contact.active}
                            onClick={() => {
                              setContactTicket(contact);
                              setNewTicketModalOpen(true);
                            }}
                          >
                            {contact.channel === "whatsapp" && (
                              <WhatsApp style={{ color: "green" }} />
                            )}
                            {contact.channel === "instagram" && (
                              <Instagram style={{ color: "purple" }} />
                            )}
                            {contact.channel === "facebook" && (
                              <Facebook style={{ color: "blue" }} />
                            )}
                          </IconButton>
                        </span>
                      </Tooltip>

                      <Tooltip title={i18n.t("contacts.tooltips.edit")}>
                        <IconButton
                          size="small"
                          onClick={() => hadleEditContact(contact.id)}
                        >
                          <EditIcon color="secondary" />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title={contact.active ? i18n.t("contacts.tooltips.block") : i18n.t("contacts.tooltips.unblock")}>
                        <IconButton
                          size="small"
                          onClick={
                            contact.active
                              ? () => {
                                  setConfirmOpen(true);
                                  setBlockingContact(contact);
                                }
                              : () => {
                                  setConfirmOpen(true);
                                  setUnBlockingContact(contact);
                                }
                          }
                        >
                          {contact.active ? (
                            <BlockIcon color="secondary" />
                          ) : (
                            <CheckCircleIcon color="secondary" />
                          )}
                        </IconButton>
                      </Tooltip>
                      <Can
                        role={user.profile}
                        perform="contacts-page:deleteContact"
                        yes={() => (
                          <Tooltip title={i18n.t("contacts.tooltips.delete")}>
                            <IconButton
                              size="small"
                              onClick={(e) => {
                                setConfirmOpen(true);
                                setDeletingContact(contact);
                              }}
                            >
                              <DeleteOutlineIcon color="secondary" />
                            </IconButton>
                          </Tooltip>
                        )}
                      />
                    </TableCell>
                  </TableRow>
                );
              })}
              {loading && <TableRowSkeleton avatar columns={9} />}
            </>
          </TableBody>
        </Table>
      </div>
      <TablePagination
        component="div"
        count={totalContactsCount}
        page={pageNumber - 1}
        onPageChange={(event, newPage) => setPageNumber(newPage + 1)}
        rowsPerPage={pageSize}
        onRowsPerPageChange={(event) => setPageSize(parseInt(event.target.value, 10))}
        rowsPerPageOptions={[10, 20, 50, 100]}
        labelRowsPerPage="Itens por página"
        labelDisplayedRows={({ from, to, count }) =>
          `${from}-${to} de ${count !== -1 ? count : `mais de ${to}`}`
        }
      />
    </PageBase>
  );
};

export default Contacts;
